<template>
  <result-card
    image="/img/payment-error.png"
    title="Не удалось произвести оплату"
    :note="reason || defaultReason"
    action-label="Повторить оплату"
    @action="$emit('action')"
  />
</template>

<script>
  import ResultCard from './ResultCard'

  export default {
    name: 'PaymentFailed',
    components: { ResultCard },
    props: {
      reason: {
        type: String,
        default: '',
      },
    },
    data () {
      return {
        defaultReason: 'Платеж отклонён банком. Попробуйте другой способ оплаты или повторите позже.',
      }
    },
  }
</script>
